module.exports = __webpack_public_path__ + "static/media/6450.8a317afe.jpg";